var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"rgba(0, 0, 0, 0.4)","position":"fixed","top":"0","bottom":"0","left":"0","right":"0","z-index":"100000","color":"white"}},[_vm._v(" "+_vm._s(_vm.$t('loading'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }